function binary (event) {
  var mainGrid = document.getElementById('product-grid');
  var card = document.getElementsByClassName('card--standart');
  mainGrid.classList.remove('grid--1-col-tablet-down');
  mainGrid.classList.add('grid--2-col-tablet-down');
  $('.card-wrapper .card').removeClass('card-horizontal');
};

function single (event) {
  var mainGrid = document.getElementById('product-grid');
  var card = document.getElementsByClassName('card--standart');
  mainGrid.classList.remove('grid--2-col-tablet-down');
  mainGrid.classList.add('grid--1-col-tablet-down');
  $('.card-wrapper .card').addClass('card-horizontal');
  $('.card-wrapper .card').removeClass('card--standart');
};


var header = document.getElementById("steep");
var colorbtn = header.getElementsByClassName("colorbtn");
for (var i = 0; i < colorbtn.length; i++) {
  colorbtn[i].addEventListener("click", function() {
  var current = document.getElementsByClassName("online");
  current[0].className = current[0].className.replace("online", "");
  this.className += " online";
  });
}
window.addEventListener("DOMContentLoaded",function(){
  checkMobileLayoutCookie();
})
